import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/AboutPage/aboutsection.css';
import {
  FaTrophy,
  FaChartPie,
  FaUser,
  FaCheckCircle,
  FaUsers,
  FaAward,
} from 'react-icons/fa';

import { ArrowRight } from 'lucide-react';

function AboutSection() {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/contact');
  };

  return (
    <div className="about-wrapper">

      {/* Section 1: Intro */}
      <div className="about-section first">
        <div className="about-images">
          <img
            src={require('../../assets/aboutus_image.jpg')}
            alt="Working Woman"
            className="main-img"
          />
        </div>
        <div className="about-content">
          <h2>
            Empowering Europe's Digital Future with <span className="highlight">VSK Global Infotech</span>
          </h2>
          <p className="desc">
            VSK Global Infotech is a Europe-based IT consulting and recruitment company helping organizations transform and grow through cutting-edge technology and top-tier talent.
            <br /><br />
            Operating across the Netherlands, Poland, Germany, Belgium, and the UK, we blend innovative IT services with workforce solutions tailored for every client.
          </p>

          <div className="features">
            <div><FaTrophy className="icon" /> Trusted Across Europe</div>
            <div><FaChartPie className="icon" /> Scalable & Agile Delivery</div>
          </div>

          <div className="author">
            <button onClick={handleNavigate} className="aboutpage-button">
              <span>Know more</span>
              <ArrowRight size={20} />
            </button>
            <div className="profile">
              <img
                src="https://randomuser.me/api/portraits/women/65.jpg"
                alt="Awet Nasih"
              />
              <div>
                <strong>Awet Nasih</strong>
                <p>Co-Founder</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Vision + Mission */}
      <div className="about-section vision-mission-row">
        <div className="vision-mission-box bg1">
          <h3>Our <span className="highlight">Vision</span></h3>
          <p>To be a trusted technology and talent partner powering digital transformation across Europe.</p>
          <br />
        </div>
        <div className="vision-mission-box bg8">
          <h3>Our <span className="highlight">Mission</span></h3>
          <p>To deliver innovative, secure, and scalable solutions that solve real-world business problems while also connecting clients with the best IT talent available globally.</p>

        </div>
      </div>

      {/* Section 3: Strengths + Who We Work With */}
      <div className="about-section grid-section">
        {/* Our Strengths */}
        <h3 className="center-title">Our Strengths</h3>
        <div className="info-grid">
          <div className="bg1">Multi-Cloud & DevOps Expertise</div>
          <div className="bg2">Deep Network of IT Professionals Across Europe & India</div>
          <div className="bg3">Scalable Delivery Models: On-site | Remote | Nearshore</div>
          <div className="bg4">Agile-Focused, Outcome-Driven Engagements</div>
          <div className="bg5">High Retention & Client Satisfaction Rates</div>
        </div>

        {/* Who We Work With */}
        <h3 className="center-title">Who We Work With</h3>
        <div className="info-grid">
          <div className="bg6">Tech Startups</div>
          <div className="bg7">Financial Institutions</div>
          <div className="bg8">Logistics & Supply Chain Enterprises</div>
          <div className="bg1">Healthcare & Life Sciences</div>
          <div className="bg2">Public Sector Organizations</div>
        </div>
      </div>

      {/* Section 4: Stats at Bottom */}
      <div className="about-section stats-bottom">
        <div className="stats-grid">
          <div className="stat"><FaUser className="icon" /><div><h3>1160+</h3><p>Happy Clients</p></div></div>
          <div className="stat"><FaCheckCircle className="icon" /><div><h3>1545+</h3><p>Projects Done</p></div></div>
          <div className="stat"><FaUsers className="icon" /><div><h3>50+</h3><p>Skilled Experts</p></div></div>
          <div className="stat"><FaAward className="icon" /><div><h3>25</h3><p>Won Award</p></div></div>
        </div>
      </div>
    </div>
  );
}

export default AboutSection;
